(() => {
  const formatMoney = (cents, currency) => new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
  }).format(cents / 100);

  const initialize = (root) => {
    if (root.dataset.kpInitialized === 'true') return;
    root.dataset.kpInitialized = 'true';

    const choices = [...root.querySelectorAll('.kp-multi-service__choice')];
    const requiredChoices = [...root.querySelectorAll('[data-kp-required-service]')];
    const total = root.querySelector('[data-kp-multi-service-total]');
    const addButton = root.querySelector('[data-kp-multi-service-add]');
    const error = root.querySelector('[data-kp-multi-service-error]');
    const currency = root.dataset.currency || 'USD';
    const requiresPackage = root.dataset.mode === 'tune-with-addons';

    const selected = () => choices.filter((choice) => choice.checked && !choice.disabled);
    const hasRequiredPackage = () => !requiresPackage || requiredChoices.some((choice) => choice.checked && !choice.disabled);
    const isReady = () => hasRequiredPackage() && selected().length > 0;

    const update = () => {
      const cents = selected().reduce(
        (sum, choice) => sum + Number(choice.dataset.priceCents || 0),
        0,
      );
      total.textContent = formatMoney(cents, currency);
      addButton.disabled = !isReady();
      error.hidden = true;
      error.textContent = '';
    };

    choices.forEach((choice) => choice.addEventListener('change', () => {
      const group = choice.dataset.kpExclusiveGroup;
      if (choice.checked && group) {
        choices.forEach((candidate) => {
          if (candidate !== choice && candidate.dataset.kpExclusiveGroup === group) {
            candidate.checked = false;
          }
        });
      }
      update();
    }));

    addButton.addEventListener('click', async () => {
      if (!isReady()) {
        error.textContent = requiresPackage
          ? root.dataset.requiredMessage || 'Choose a package before adding services.'
          : 'Select at least one service.';
        error.hidden = false;
        return;
      }

      const items = selected().map((choice) => ({
        id: Number(choice.value),
        quantity: 1,
      }));

      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      const originalText = addButton.textContent;
      addButton.textContent = 'Adding services…';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          const details = await response.json().catch(() => ({}));
          throw new Error(details.description || details.message || 'Unable to add the selected services.');
        }

        window.location.assign(root.dataset.cartUrl || '/cart');
      } catch (caught) {
        error.textContent = caught instanceof Error ? caught.message : 'Unable to add the selected services.';
        error.hidden = false;
        addButton.disabled = !isReady();
        addButton.removeAttribute('aria-busy');
        addButton.textContent = originalText;
      }
    });

    update();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-kp-multi-service]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();

